import styled from 'styled-components'
import { colors, breakpoints } from '@/styles'
import { Label } from '@/components/text'
import { Stack, Box } from '@/components/structure'

export const InfoContainer = styled.div`
  background: ${colors.grey96};
  border-radius: 16px;
  padding: 16px;
  gap: 24px;
  flex: 1;
  display: flex;
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    flex-direction: column;
    padding: 24px;
    width: 100%;
  }
`

export const ItemList = styled.dl`
  flex: 1;
  gap: 20px 24px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const StyledLabel = styled(Label)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

type ItemProps = {
  children: React.ReactNode
}

export const ItemWrapper: React.FC<ItemProps> = ({ children, ...rest }) => (
  <Stack gutter="8px">{children}</Stack>
)

export const ItemDescription: React.FC<ItemProps> = ({ children, ...rest }) => (
  <Box color={colors.grey56} as="dt">
    <Label fontSize="12px" as="span" {...rest}>
      {children}
    </Label>
  </Box>
)

export const ItemValue: React.FC<ItemProps> = ({ children, ...rest }) => (
  <Box color={colors.grey16} as="dd">
    <StyledLabel fontSize="14px" as="span" {...rest}>
      {children}
    </StyledLabel>
  </Box>
)
